import { LANGUAGES } from 'state/intl/types';
import { Region } from 'utils/environment/types';

export const regionSupportedLanguages = {
  [Region.US]: new Set([LANGUAGES.en]),
  [Region.CA]: new Set([LANGUAGES.fr, LANGUAGES.en]),
};
